<template>
  <order-received />
</template>

<script>
import OrderReceived from '@/components/order/OrderReceived'

export default {
  name: 'OrderReceivedPage',
  metaInfo() {
    return {
      title: this.$t('meta.other.titleTmpl', {
        h1: this.$t('thankyou'),
      }),
      meta: [
        {
          name: 'robots',
          content: 'noindex, follow',
        },
        {
          name: 'description',
          content: this.$t('meta.other.descriptionTmpl', {
            h1: this.$t('thankyou'),
          }),
        },
      ],
    }
  },
  components: { OrderReceived },
}
</script>
